import { isEmptyArray } from './array-utils';
/**
 * Generates a query string from a query object.
 *
 * @param query The query object to convert to a string.
 */
export const generateQueryKey = (query) => {
    const entries = Object.entries(query).sort();
    const queryKeyComponents = entries.reduce((acc, [key, value]) => {
        if (Array.isArray(value)) {
            acc.push(`${key}=${value.slice().sort().join(',')}`);
        }
        else if (value != null) {
            // Exclude null/undefined values
            acc.push(`${key}=${value}`);
        }
        return acc;
    }, []);
    if (isEmptyArray(queryKeyComponents))
        return 'all';
    return queryKeyComponents.join('&');
};
